module.exports = __webpack_public_path__ + "static/media/ec-api.f7fbda35.png";